export type ServiceCard = {
  slug: string
  title: string
  short: string
  description: string
  team: string
}

export const FEATURED_SERVICES: ServiceCard[] = [
  {
    slug: 'commercial-business-law',
    title: 'Commercial & Business Law',
    short: 'Get clarity before you sign, sell, buy or restructure.',
    description:
      'Contracts, business structures, shareholder agreements, business sales, succession and commercial risk.',
    team: 'Commercial team',
  },
  {
    slug: 'dispute-resolution',
    title: 'Dispute Resolution & Litigation',
    short: 'Resolve disputes strategically and proportionately.',
    description:
      'Commercial, employment, property, estate and professional negligence disputes — resolved with a clear strategy.',
    team: 'Litigation team',
  },
  {
    slug: 'property-law',
    title: 'Property Law',
    short: 'Confident advice across residential, commercial and development.',
    description:
      'Legal advice for residential, commercial and development property matters across WA.',
    team: 'Property team',
  },
  {
    slug: 'conveyancing',
    title: 'Conveyancing & Settlements',
    short: 'Premium settlement support that keeps deals on track.',
    description:
      'Settlement support for buyers, sellers, investors and developers across Western Australia.',
    team: 'Settlements team',
  },
  {
    slug: 'family-law',
    title: 'Family Law',
    short: 'Calm, clear guidance through a difficult time.',
    description:
      'Divorce, property settlements, parenting arrangements, child support, mediation and binding financial agreements.',
    team: 'Family team',
  },
  {
    slug: 'wills-estates',
    title: 'Wills, Estates & Succession Planning',
    short: 'Protect what you have built and the people who matter.',
    description:
      'Wills, EPAs, EPGs, estate planning, testamentary trusts and business succession planning.',
    team: 'Estates team',
  },
  {
    slug: 'franchising',
    title: 'Franchising Law',
    short: 'Know exactly what you are committing to.',
    description:
      'Advice for franchisors and franchisees before, during and after signing.',
    team: 'Franchising team',
  },
  {
    slug: 'employment',
    title: 'Employment & Workplace Relations',
    short: 'Handle workplace issues correctly the first time.',
    description:
      'Employment contracts, workplace issues, disputes, restraints, safety and compliance.',
    team: 'Workplace team',
  },
]
